import { Button, Box } from '@mui/material'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import qs from 'querystring'

import { CustomList, CustomListHeader } from '../../../components'
import { FlexRow, FlexCol } from '../../../components/Flex'
import GeoclaimListContent from './ListContent'
import GeoclaimCreditsListContent from '../GeoclaimCreditsPage/ListContent'

const UnifiedGeoclaimsList = ({ initialTab }: { initialTab: string }) => {
  const [tab, setTab] = useState(initialTab)

  return (
    <CustomList
      header={
        <CustomListHeader sx={{ alignItems: 'stretch', flexDirection: 'row' }} title="Geoclaims">
          <FlexRow>
            <Box flexGrow={1} />
            <FlexRow>
              <Button
                size="small"
                onClick={() => setTab('claims')}
                color={tab === 'claims' ? 'primary' : 'inherit'}
                variant={tab === 'claims' ? 'contained' : 'text'}
              >
                Claims
              </Button>
              <Button
                size="small"
                onClick={() => setTab('credits')}
                color={tab === 'credits' ? 'primary' : 'inherit'}
                variant={tab === 'credits' ? 'contained' : 'text'}
              >
                Credits History
              </Button>
            </FlexRow>
          </FlexRow>
        </CustomListHeader>
      }
    >
      <FlexCol alignItems="stretch">
        {tab === 'claims' ? <GeoclaimListContent /> : <GeoclaimCreditsListContent />}
      </FlexCol>
    </CustomList>
  )
}

export default UnifiedGeoclaimsList